<template>
  <input type="hidden" :value="currentValue" :id="formField.element_id" />
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'

export default {
  name: 'HiddenField',
  mixins: [PropsMixin, ComputedMixin],
  data () {
    return {
    }
  },
  computed: {
    values () {
      return this.formField.formListItems
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>
